'use strict';

module.exports = function whereBetween(key, values) {
  return this.where(key, '>=', values[0]).where(key, '<=', values[values.length - 1]);
};


//////////////////
// WEBPACK FOOTER
// ./~/collect.js/dist/methods/whereBetween.js
// module id = 1742
// module chunks = 2